import React from "react";
import PurchaseOrderCore from "./PurchaseOrderCore";
import SuperMarketPurchaseOrder from "./SuperMarketPurchaseOrder";
import useAuthStore from "../../stores/useAuthStore";

const PurchaseOrder = () => {
  const tillData = useAuthStore((s) => s.tillData);
  return tillData?.tillAccess ? <PurchaseOrderCore component={SuperMarketPurchaseOrder} /> : <h1>Access Denied</h1>;
};

export default PurchaseOrder;
